import React, { useEffect, useState, useContext, useCallback } from "react";
import { useForm, FormProvider, useWatch } from "react-hook-form";
import { useHistory } from "react-router-dom";
//Material

//Component
import { ReactTable } from "../../stories/react-table";
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
import { API_URL } from "../../utils/api-utils";
//Function
import { getViewExportColumns } from "./columns/export-history";
import { GetUser } from "../../utils/sessions";
import { GetListDownloadHeader, DownloadFile } from "./api";
import { formatDateTime } from "../../utils/common-function";
import XLSX from 'xlsx';
import { url, method } from "./signalr";
import { useSignalR } from "./../function-api/useSignalR";
import * as alertDialog from "./../../utils/alert";
import ViewDetail from "./view-detail";

function ExportHistory() {
  //State
  const [DataList, setDataList] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [detail, setDetail] = useState();
  const [keepSearch, setKeepSearch] = useState(false);
  const history = useHistory();
  //Effect
  useEffect(() => {

    fetch();
    localStorage.setItem("SearchTable","");
  }, []);

  const fetch = async () => {
    let param = { "USER_ID": GetUser(), "MODE": "Refresh" };
    let res = await GetListDownloadHeader(param);
    setDataList(res);
  }

  const signalRHandler = useCallback(async (data) => {
    //console.log(data);
    fetch();
    setKeepSearch(true);
    //setDataList(data)
  }, []);

  useSignalR(url, method, signalRHandler);

  const onOpenAddModal = () => {
    history.push("/DecryptScreen");
  }

  const onCloseViewModal = () => {
    setOpenModal(false);
  };

  const onViewModal = (pID) => {
    const fetch = async () => {
      let res = DataList.find((e) => e.ID === pID);
      //console.log(res);
      setDetail(res);
    }
    fetch();
    setOpenModal(true);
  }

  // const onExportData = async (pDOWNLOAD_ID) =>{
  //   let nameFile = "Export -" + formatDateTime(new Date()) + '.csv';
  //   let param = { DOWNLOAD_ID: pDOWNLOAD_ID };
  //   let res = await DownloadCSV(param);
  //   const blob = new Blob(['\ufeff'+res], { type: "text/csv; charset=UTF-8;"});
  //   const url = window.URL.createObjectURL(blob);
  //   const a = document.createElement('a');
  //   a.setAttribute('hidden', '');
  //   a.setAttribute('href', url);
  //   a.setAttribute('download', nameFile);
  //   document.body.appendChild(a);
  //   a.click();
  //   document.body.removeChild(a);

  // }

  const onExportData = async (pID) => {
    let param = { "ID": pID };
    let res = await DownloadFile(param);
    //console.log(res);
    if (res?.FileName)
      window.open(`${API_URL.Loader}/Export/` + res?.FileName, '_blank');
    else
      alertDialog.ErrorDialog("Error : File Not Found");
  }

  // const onExportData = async (pDOWNLOAD_ID) => {
  //   let nameFile = "Export -" + formatDateTime(new Date()) + '.csv';
  //   let param = { DOWNLOAD_ID: pDOWNLOAD_ID };
  //   let res = await DownloadCSV(param);
  //   var wb = XLSX.read(res,
  //     {
  //       type: "binary", 
  //       cellNF: true, 
  //       //cellDates: false, 
  //       cellText: false, 
  //       raw: true
  //       //dateNF: "d-mmm-yyyy"
  //     });
  //   XLSX.writeFile(wb, nameFile,{cellDates: false,bookType:"csv"});
  //   //console.log(wb);

  // }



  return (
    <div>
      <BaseContainer maxWidth={false}>
        <BoxTemplate1 height="80vh" title="Decrypt Export" 
        // add onClickAdd={onOpenAddModal}
        >
          <FormProvider>
            <ReactTable
              keyField="ID"
              data={DataList}
              columns={getViewExportColumns(onExportData,onViewModal)}
              addButton={true}
              handleOnAdd={(e) => onOpenAddModal()}
              keepStateSearch={keepSearch}
            />
          </FormProvider>
        </BoxTemplate1>
        <ViewDetail
          open={openModal}
          onClose={onCloseViewModal}
          Detail={detail}
        />
      </BaseContainer>
    </div>
  );
}
export default ExportHistory;
